import { cacheKeys } from "config";
import { useQuery } from "react-query";
import { PaginationApiParams } from "@coolset/cs-ui";
import { supportingInfoClient } from "modules/SupportingInfo/client/supportingInfoClient";

export const useSupportingInfoData = (getAllParams?: PaginationApiParams, id?: number | string | null) => {
  const { data: { data: supportingInfosData } = {}, isLoading: isLoadingInfos } = useQuery(
    [cacheKeys.supportingInfo.getSupportingInfos, getAllParams],
    () => supportingInfoClient.getSupportingInfos({ isParent: true, ...getAllParams })
  );

  const { data: supportingInfoData, isLoading: isLoadingInfo } = useQuery(
    [cacheKeys.supportingInfo.getSupportingInfo, id],
    () => {
      if (!id) {
        return;
      }
      return supportingInfoClient.getSupportingInfo(id);
    }
  );

  return {
    supportingInfos: supportingInfosData?.results || [],
    supportingInfosCount: supportingInfosData?.count || 0,
    supportingInfo: supportingInfoData?.data,
    isLoadingInfos,
    isLoadingInfo,
  };
};
